import React from 'react';
import { Layout, Menu } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import { Route, Switch } from 'react-router-dom';
import { pages } from './../Landing/Landing';
import { injectIntl } from 'react-intl';
import SwitchLanguageButton from './../LangSwitcher'

const { Sider } = Layout;

const HomeSider = injectIntl(({ collapsed, siderToggled, intl: { formatMessage } }) => (
	<Sider
		className="Sider"
		trigger={null}
		collapsed={collapsed}
		defaultCollapsed={true}
		collapsible
		collapsedWidth="0"
		onCollapse={(collapsed, type) => siderToggled({ collapsed, type })}
	>
		<Menu mode="inline">
			{Object.keys(pages).filter(p => pages[p].visible).map(
				p => <Menu.Item key={p}>
					<Link
						duration={300}
						delay={100}
						spy={true}
						smooth={true}
						hashSpy={true}
						to={p}>{formatMessage(pages[p].title)}
					</Link>
				</Menu.Item>
			)
			}
		</Menu>
		<div className="lang">
			<SwitchLanguageButton />
		</div>
	</Sider>
));

const S = (props, { siderToggled }) => (
	<Switch>
		<Route exact path="/" render={() => <HomeSider {...props} siderToggled={siderToggled}/>}/>
		<Route path="*" component={() => null}/>
	</Switch>
);

S.contextTypes = {
	siderToggled: PropTypes.func,
};

export default S;


// WEBPACK FOOTER //
// ./src/components/Sider/Sider.js